import { darken, getLuminance, lighten } from 'polished';

export function getHoveredOrSelectedColour(color: string, level: number) {
	const colourLuminance = getLuminance(color);
	if (colourLuminance < 0.5) {
		return darken(level, color);
	}
	return lighten(level, color);
}
